import { Logger } from 'data/common';

let environment = '';

function debug(eventName, params) {
    Logger.debug(`${environment} : <---------- Event Received ${eventName}`, params);
}

function bindSettingsEvents(BoxInstance) {
    BoxInstance.socketOn('VPNBoxStarted', function(args) {
        const { fheCenter_mac: macAddress, ip_address: ipAddress } = args;
        debug('VPNBoxStarted', args);

        if (macAddress === undefined || ipAddress === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket VPNBoxStarted : "${args}"`);
        if (!BoxInstance.getState().environments[BoxInstance.environment].data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le ${BoxInstance.environment}-Center "${macAddress}" n'est pas présent dans le store`);
        BoxInstance.dispatch({
            type: `${BoxInstance.environment.toUpperCase()}__UPDATE_BOX_IP`,
            macAddress,
            ipAddress
        });
    });

    BoxInstance.socketOn('VPNBoxStopped', function(args) {
        const { fheCenter_mac: macAddress } = args;
        debug('VPNBoxStopped', args);

        if (macAddress === undefined) return Logger.error(`Arguments manquants sur l'envent socket VPNBoxStopped : "${args}"`);
        if (!BoxInstance.getState().environments[BoxInstance.environment].data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le ${BoxInstance.environment}-Center "${macAddress}" n'est pas présent dans le store`);
        BoxInstance.dispatch({
            type: `${BoxInstance.environment.toUpperCase()}__UPDATE_BOX_IP`,
            macAddress,
            ipAddress: null
        });
    });

    BoxInstance.socketOn('boxSysInfo', function(args) {
        const {
            fheCenter_mac: macAddress,
            time_diff: timeDiff,
            dns_resolv: dnsResolv,
            free_space: freeSpace,
            zwave_status: zwaveStatus,
            version
        } = args;
        debug('boxSysInfo', args);

        if (
            macAddress === undefined ||
            timeDiff === undefined ||
            dnsResolv === undefined ||
            freeSpace === undefined ||
            zwaveStatus === undefined ||
            version === undefined
        )
            return Logger.error(`Arguments manquants sur l'envent socket boxSysInfo : "${args}"`);
        if (!BoxInstance.getState().environments[BoxInstance.environment].data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le ${BoxInstance.environment}-Center "${macAddress}" n'est pas présent dans le store`);

        let boxSysInfo = {
            timeDiff: timeDiff,
            dnsResolv: dnsResolv,
            freeSpace: parseInt(freeSpace),
            zwaveStatus: zwaveStatus,
            firmwareVersion: version
        };

        BoxInstance.dispatch({
            type: `${BoxInstance.environment.toUpperCase()}__UPDATE_BOX_SYS_INFO`,
            macAddress,
            boxSysInfo
        });
    });

    BoxInstance.socketOn('boxConnected', function(args) {
        const { fheCenter_mac: macAddress } = args;
        debug('boxConnected', args);

        if (macAddress === undefined) return Logger.error(`Arguments manquants sur l'envent socket boxConnected : "${args}"`);
        if (!BoxInstance.getState().environments[BoxInstance.environment].data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le ${BoxInstance.environment}-Center "${macAddress}" n'est pas présent dans le store`);

        BoxInstance.dispatch({
            type: `${BoxInstance.environment.toUpperCase()}__UPDATE_BOX_STATUS`,
            macAddress,
            boxIsConnected: 1
        });

        BoxInstance.emit(`boxStatusChange${macAddress}`, 1);
    });
    BoxInstance.socketOn('boxDisconnected', function(args) {
        const { fheCenter_mac: macAddress } = args;
        debug('boxDisconnected', args);

        if (macAddress === undefined) return Logger.error(`Arguments manquants sur l'envent socket boxDisconnected : "${args}"`);
        if (!BoxInstance.getState().environments[BoxInstance.environment].data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le ${BoxInstance.environment}-Center "${macAddress}" n'est pas présent dans le store`);

        BoxInstance.dispatch({
            type: `${BoxInstance.environment.toUpperCase()}__UPDATE_BOX_STATUS`,
            macAddress,
            boxIsConnected: 0
        });

        BoxInstance.emit(`boxStatusChange${macAddress}`, 0);
    });
}

export default function initBinds(BoxInstance) {
    environment = BoxInstance.environment;
    bindSettingsEvents(BoxInstance);
}



// WEBPACK FOOTER //
// ./environments/genericEnv/eventsSocket/Box/binds.js